import React from 'react';
import { motion } from 'framer-motion';
import { usePrefersReducedMotion } from '../hooks/useMedia';

/** Fast, elegant route transition wrapper. */
export function PageTransition({
  children
}: {
  children: React.ReactNode;
}) {
  const reduced = usePrefersReducedMotion();
  if (reduced) return <>{children}</>;
  return <motion.div initial={{
    opacity: 0,
    y: 14
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -8
  }} transition={{
    duration: 0.45,
    ease: [0.16, 1, 0.3, 1]
  }} data-id="element-400" data-mp="2u3e915zxa3ix">
      {children}
    </motion.div>;
}